import React from 'react';

// Styles & Assets
import styles from './SidebarButton.module.css';

// Other
import { Link, LinkProps } from 'react-router-dom';

interface Props {
    active: boolean,
    disabled?: boolean
    handleClick: () => void,
    buttonInfo: {
        label: string;
        link: string;
        icon: JSX.Element;
        props?: Partial<LinkProps>
    }
}
// SidebarButton: component that renders a link with an
// icon and a text on its right. Received props:
//  -active: whether the link is active
//  -handleClick: handles the link click
//  -buttonInfo: label, link and icon to render

const SidebarButton: React.FC<Props> = ({ active, disabled, handleClick, buttonInfo }) => {

    const classes = `${styles.sidebarButton} ${active ? styles.activeButton : ''} ${disabled ? styles.disabled : ''}`;

    return (
        <Link to={disabled ? '#' : buttonInfo.link} onClick={handleClick} className={classes} {...buttonInfo.props}>
            {buttonInfo.icon}
            < span > {buttonInfo.label}</span >
        </Link >
    );
};

export default SidebarButton;